/* 
    Referencia: 

      Função para transformar data URI em Blob

      https://stackoverflow.com/questions/4998908/convert-data-uri-to-file-then-append-to-formdata/5100158
    
*/

export const dataToBlob = image => {
  let byteString = window.atob(image.split(",")[1])

  let ab = new ArrayBuffer(byteString.length)

  let ia = new Uint8Array(ab)

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }

  let contentType = image.split(";")[0].split("data:")[1]

  return new Blob([ab], { type: contentType })
}
